var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c("span", {
        staticClass:
          "icon icon-charger-availability-off charger-icon-size text-gray4",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "charger-infos" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "icon icon-charger-availability charger-icon-size position-relative right-15 text-gray4",
              attrs: { "aria-hidden": true },
            },
            [
              _c("p", {
                staticClass: "visually-hidden",
                domProps: {
                  innerHTML: _vm._s(_vm.chargerInfos.iconMessageAccessibility),
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "py-0 fw-bold text" }, [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.chargerInfos.powerMin + "-" + _vm.chargerInfos.powerMax
                ),
              },
            }),
            _vm._v(" "),
            _c("div", [_vm._v("W")]),
            _vm._v(" "),
            _vm.chargerInfos.compatiblePDC
              ? _c("div", [
                  _vm._v("\n                    USB PD\n                "),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "#",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal-charger-compatible",
                "aria-label": _vm.chargerInfos.iconMessageAccessibility,
              },
            },
            [
              _c("strong", {
                staticClass: "position-relative right-15",
                domProps: {
                  innerHTML: _vm._s(_vm.chargerInfos.compatibleMessage),
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ob1-popin-modal-visual", {
        attrs: {
          id: "modal-charger-compatible",
          "aria-labelledby": "modal-label-charger-compatible",
          "additional-classes": "d-webview-none d-md-block",
        },
        scopedSlots: _vm._u([
          {
            key: "visual",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    class: [
                      "ob1-modal-img",
                      _vm.isSoshShop ? "bg-primary3" : "bg-black",
                    ],
                  },
                  [
                    _c("div", { staticClass: "charger-popin-infos" }, [
                      _c("div", {
                        staticClass:
                          "icon icon-charger-availability charger-popin-icon-size text-white",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            "py-0 fw-bold text",
                            _vm.isSoshShop ? "text-white" : "text-dark",
                          ],
                        },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.chargerInfos.powerMin +
                                  "-" +
                                  _vm.chargerInfos.powerMax
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [_vm._v("W")]),
                          _vm._v(" "),
                          _vm.chargerInfos.compatiblePDC
                            ? _c("div", [
                                _vm._v(
                                  "\n                            USB PD\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("p", {
                  staticClass: "h4",
                  attrs: { id: "modal-charger-compatible" },
                  domProps: { innerHTML: _vm._s(_vm.chargerInfos.popinTitle) },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.chargerInfos.popinText) },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }